var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogStat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blog"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57692 0H27.4231C29.3986 0 31 1.58299 31 3.53571V29.4643C31 31.417 29.3986 33 27.4231 33H3.57692C1.60144 33 0 31.417 0 29.4643V3.53571C0 1.58299 1.60144 0 3.57692 0ZM7.15385 28.2857H23.8462C24.5046 28.2857 25.0385 27.7581 25.0385 27.1071C25.0385 26.4562 24.5046 25.9286 23.8462 25.9286H7.15385C6.49535 25.9286 5.96154 26.4562 5.96154 27.1071C5.96154 27.7581 6.49535 28.2857 7.15385 28.2857ZM23.8462 23.5714H7.15385C6.49535 23.5714 5.96154 23.0438 5.96154 22.3929C5.96154 21.7419 6.49535 21.2143 7.15385 21.2143H23.8462C24.5046 21.2143 25.0385 21.7419 25.0385 22.3929C25.0385 23.0438 24.5046 23.5714 23.8462 23.5714ZM23.8462 17.6786C25.1631 17.6786 26.2308 16.6232 26.2308 15.3214V7.07143C26.2308 5.76961 25.1631 4.71429 23.8462 4.71429H7.15385C5.83686 4.71429 4.76923 5.76961 4.76923 7.07143V15.3214C4.76923 16.6232 5.83686 17.6786 7.15385 17.6786H23.8462Z",
    fill: "#0853F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7 7H24V15H7V7Z",
    fill: "#0853F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogStat);
export default __webpack_public_path__ + "static/media/blog-stat.afef1d0dfca90698420d53c2a75ced36.svg";
export { ForwardRef as ReactComponent };